/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_MaterialInputs */

const en_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material`)
};

const es_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material`)
};

const fr_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matière`)
};

const de_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material`)
};

const ja_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`素材`)
};

const zh_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`材质`)
};

const ar_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المادة`)
};

const id_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material`)
};

const it_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materiale`)
};

const ru_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Материал`)
};

const pt_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material`)
};

const ko_field_material = /** @type {(inputs: Field_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소재`)
};

/**
* | output |
* | --- |
* | "Material" |
*
* @param {Field_MaterialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_material = /** @type {((inputs?: Field_MaterialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_MaterialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_material(inputs)
	if (locale === "es") return es_field_material(inputs)
	if (locale === "fr") return fr_field_material(inputs)
	if (locale === "de") return de_field_material(inputs)
	if (locale === "ja") return ja_field_material(inputs)
	if (locale === "zh") return zh_field_material(inputs)
	if (locale === "ar") return ar_field_material(inputs)
	if (locale === "id") return id_field_material(inputs)
	if (locale === "it") return it_field_material(inputs)
	if (locale === "ru") return ru_field_material(inputs)
	if (locale === "pt") return pt_field_material(inputs)
	return ko_field_material(inputs)
});